<div class="side-sheet active">
  <div class="d-flex h-100">

    <div class="overlay" (click)="closeCheckout()"></div>

    <div class="sheet-container checkout">

      <div class="sheet-head">
        <div class="title">{{'checkout.Check out' | translate}}</div>

        <button type="button" mat-icon-button [disabled]="dataLoading || actionLoading" (click)="closeCheckout()">
          <img src="./assets/images/icons/close.svg" alt="">
        </button>
      </div>

      <div *ngIf='(dataLoading || actionLoading) && hardReload' class="dataLoading">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
      </div>

      <ng-container *ngIf="(!dataLoading && !actionLoading) || !hardReload">

        <div class="sheet-content">

          <app-prices-details *ngIf="CheckOutModel.checkOutType == 'Total'"
            [orderDetails]="details"></app-prices-details>

          <app-prices-details *ngIf="CheckOutModel.checkOutType == 'SplitItem'"
            [checkoutType]="'split'"
            [orderDetails]="splitedItemsDetails"></app-prices-details>

          <app-prices-details *ngIf="CheckOutModel.checkOutType == 'SplitPrice'"
            [checkoutType]="'split'"
            [orderDetails]="splitedPricesDetails"></app-prices-details>

          <!-- Before Split -->
          <ng-container *ngIf="!isSplit">
            <div class="checkout-section">
              <ng-container *ngIf="details?.hasCashOption">
                <div class="label grey-color">{{'checkout.Cash Options' | translate}}</div>
                <div class="check-options">
                  <div *ngFor="let item of cashOptions">
                    <button matRipple (click)="paymentConfirmation(item, 'cash')">
                      <div class="font-20 fontSemiBold">{{item}}</div>
                      <div class="fontMedium">{{currency.currencyCode}}</div>
                    </button>
                  </div>
                </div>
              </ng-container>
              <div class="check-options no-cash-options">
                <div *ngIf="details?.hasCashOption">
                  <button matRipple (click)="manualCash = true">
                    {{'checkout.More Cash Options' | translate}}
                  </button>
                </div>
                <div *ngIf="CheckOutModel.checkOutType == 'Total' && canSplit">
                  <!-- class=orange -->
                  <button matRipple class="" (click)="isSplit = true">
                    {{'checkout.Split Payment' | translate}}
                  </button>
                </div>
              </div>
            </div>

            <div class="checkout-section" *ngIf="details.paymentOptions?.length">
              <div class="label grey-color">{{'checkout.Other Payment options' | translate}}</div>
              <div class="check-options pay-methods">
                <ng-container *ngFor="let item of details.paymentOptions">
                  <div [class.active]="item.isUsed" [hidden]="!isIOSDevice && (item.lookupCode == 'ApplePay')">
                    <!-- [class.active]="item.isUsed && checkoutId" -->
                    <button matRipple (click)="selectedPaymentOpt = item; prepareCheckOut()">
                      <div [innerHTML]="item.icon! | sanitizeHtml"></div>
                      <!-- <div>
                        <div class="font-14 fontMedium mt-2">{{item.name}}</div>
                      </div> -->
                    </button>
                  </div>
                </ng-container>
              </div>

              <ng-container *ngIf="selectedPaymentOpt?.lookupCode == 'Other'">
                <div class="mt-4">
                  <form [formGroup]="otherPaymnetFormGroup" (ngSubmit)="otherPaymentCheckout()">
                    <mat-form-field class="mb-2" hideRequiredMarker>
                      <mat-label>{{ 'placeOrder.Payment option' | translate }}</mat-label>
                      <mat-select formControlName="otherPaymentOptionsId">
                        <mat-option [value]="option.id" *ngFor="let option of details.otherPaymentOptions">
                          <span>{{option.name}}</span>
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="PaymnetFormError('otherPaymentOptionsId', 'required')">
                        {{ 'forms.Required' | translate }}</mat-error>
                    </mat-form-field>
                    <mat-form-field hideRequiredMarker>
                      <mat-label>{{ 'placeOrder.Write a comment' | translate }}</mat-label>
                      <textarea matInput formControlName="otherPaymentOptionsComment"
                        cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                        cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5" maxlength="400"></textarea>
                      <mat-error *ngIf="PaymnetFormError('otherPaymentOptionsComment', 'required')">
                        {{ 'forms.Required' | translate }}</mat-error>
                    </mat-form-field>

                    <div class="text-right">
                      <button mat-raised-button color="primary"
                        [disabled]="!otherPaymnetFormGroup.valid">
                        {{'checkout.Pay' | translate}}
                      </button>
                    </div>
                  </form>
                </div>
              </ng-container>

              <div class="button-group-custom mb-0"
                *ngIf="selectedPaymentOpt?.lookupCode !== 'Other'
                    && selectedPaymentOpt?.lookupCode !== 'HouseAccount'
                    && selectedPaymentOpt?.lookupCode !== 'NearPayNFC'"
                [hidden]="!selectedPaymentOpt">
                <mat-button-toggle-group [(ngModel)]="paymentWay" (change)="ResGetCheckoutId()">
                    <mat-button-toggle value="qrCode">{{'orders.Client' | translate}}</mat-button-toggle>
                    <mat-button-toggle value="system">{{'orders.System' | translate}}</mat-button-toggle>
                </mat-button-toggle-group>
              </div>
            </div>

            <ng-container *ngIf="checkoutId && checkoutIdRes">
              <div *ngIf="paymentWay == 'qrCode'">
                <div class="alert alert-warning">
                  <div class="d-flex align-items-center">
                    <div class="icon">
                      <img src="./assets/images/icons/warning-ic.svg" alt="">
                    </div>
                    <div>
                      <p class="font-15">{{"orders.Please, Don't change payment option after the client scan Qr code" | translate}}</p>
                    </div>
                  </div>
                </div>
                <div class="text-center">
                  <img [src]="'data:image/png;base64,' + checkoutIdRes.qrCode" alt="">
                </div>
              </div>

              <ng-container *ngIf="paymentWay == 'system'">
                <iframe class="payment-online-iframe"
                  [src]="referencePaymentUrl | safe"
                  [class.loading]="paymentIframeLoader"
                  (load)="paymentIframeLoader = false"></iframe>
              </ng-container>
            </ng-container>
          </ng-container>
          <!-- END Before Split -->

          <!-- Split -->
          <ng-container *ngIf="isSplit">
            <div class="split-container">
              <div class="split-btns-container">
                <mat-button-toggle-group [(ngModel)]="splitType" (change)="$event">
                  <mat-button-toggle value="price">{{'checkout.Split by Price' | translate}}</mat-button-toggle>
                  <mat-button-toggle value="item" [disabled]="!details.canItemSplit">
                    {{'checkout.Split by Item' | translate}}</mat-button-toggle>
                </mat-button-toggle-group>

                <div class="split-price-counter" *ngIf="splitType == 'price'">
                  <button mat-icon-button class="minus"
                    (click)="minusSplitPriceList()" [disabled]="details.splitPriceList.length <= 1">
                    <mat-icon>remove</mat-icon>
                  </button>

                  <div class="inputValue">
                    <input matInput [ngModel]="details.splitPriceList.length" readonly
                      maxlength="20" appOnlynumber (change)="handleSplitPriceList()">
                    <p class="custom-error"
                      *ngIf="details.splitPriceList.length <= 0 || details.splitPriceList.length > maxSplitPrice">
                      {{ 'forms.Invalid value' | translate }}
                    </p>
                  </div>
                  <button mat-icon-button class="plus"
                    (click)="plusSplitPriceList()"
                    [disabled]="details.splitPriceList.length >= maxSplitPrice">
                    <mat-icon>add</mat-icon>
                  </button>
                </div>
              </div>
            </div>

            <!-- Price Split -->
            <ng-container *ngIf="splitType == 'price'">
              <div class="checkout-section">
                <div class="label grey-color">{{'checkout.To Pay' | translate}}</div>
                <div class="split-controls">
                  <div *ngFor="let item of details.splitPriceList; index as i">
                    <div class="control">
                      <!-- (change)="handleSplitAmountInput(item, amount)" -->
                      <ng-container *ngIf="i == (details.splitPriceList.length - 1)">
                        <div class="form-control">
                          <span>{{currency.currencyCode}}</span>
                          {{item.priceAmount}}</div>
                      </ng-container>
                      <ng-container *ngIf="i !== (details.splitPriceList.length - 1)">
                        <mat-form-field class="field-align no-label"
                          [class.mat-form-field-invalid]="!item.isValid">
                          <input matInput [(ngModel)]="item.priceAmount"
                            #amount="ngModel" name="amount{{i}}"
                            [pattern]="floatPattern"
                            (keyup)="handleSplitAmountInput(item, amount)"
                            [readonly]="item.isPaid">
                          <span matPrefix>{{currency.currencyCode}}</span>
                        </mat-form-field>
                        <p class="has-error text-right" *ngIf="!item.isValid && amount.touched">
                          {{ 'forms.Invalid' | translate }}
                        </p>
                      </ng-container>
                    </div>
                    <button mat-button color="primary" class="text-uppercase"
                      [disabled]="item.isPaid || !item.isValid"
                      (click)="getSplitedPriceDetails(item)">
                        {{'checkout.Pay' | translate}}</button>
                  </div>
                </div>
              </div>
            </ng-container>
            <!-- End Price Split -->

            <!-- Item Split -->
            <ng-container *ngIf="splitType != 'price'">
              <div class="hint">
                <p class="info font-14">{{'checkout.Simply tap on the item(s) you want to pay.' | translate}}</p>
              </div>
              <div class="checkout-section items-split">

                <div class="order-items-list p-0">
                  <div class="order-item"
                    *ngFor="let item of details.splitItemList; index as i"
                    (click)="splitItemClicked(item)"
                    [ngClass]="{
                      'active': item.active,
                      'clickable': (item.quantity == 1 || item.isWeight) && (item.quantity != item.splitedQuantity)
                    }">
                    <div class="item-info-container">
                      <div class="right d-flex">
                        <div class="img-container">
                          <img [src]="item.itemPic" alt="">
                        </div>
                        <div class="font-14 fontRegular grey-color">X{{item?.quantity}}</div>
                      </div>
                      <div class="item-details">
                        <div class="d-flex align-items-center">
                          <span class="font-14 fontSemiBold">{{item?.itemName}}</span>
                          <span class="red-color font-14 ml-auto" *ngIf="item.splitedQuantity">
                            {{'orders.Paid' | translate}} X{{item.splitedQuantity}}
                          </span>
                        </div>
                        <div class="mt-1 font-12" *ngIf="item?.sizeName">
                          <span class="grey-color">{{'orders.size' | translate}}:</span>
                          <span> {{item?.sizeName}}</span>
                        </div>
                        <div class="item-options">
                          <div *ngFor="let addition of item?.additions">
                            <div class="grey-color font-12">{{addition.kdsName}}:</div>
                            <ng-container *ngFor="let one of addition.itemAdditionlist">
                              <div class="font-12" *ngIf="one.isSelected">{{one.name}}</div>
                            </ng-container>
                          </div>
                          <div *ngFor="let variant of item?.variants">
                            <div class="grey-color font-12">{{variant.name}}:</div>
                            <ng-container *ngFor="let one of variant.itemVariantlist">
                              <div class="font-12" *ngIf="one.isSelected">{{one.name}}</div>
                            </ng-container>
                          </div>
                          <div *ngIf="item?.specialRequest">
                            <div class="orange-color font-12">{{'orders.Note' | translate}}:</div>
                            <div class="font-12">{{item.specialRequest}}</div>
                          </div>
                        </div>
                        <div class="d-flex align-items-end font-18 pt-2">
                          <ng-container *ngIf="!item.isWeight">
                            <div class="d-flex align-items-center" *ngIf="(item.quantity > 1) && (item.splitedQuantity != item.quantity)">
                              <select [(ngModel)]="item.splitQuantity"
                                (change)="item.active = (item.splitQuantity > 0 ? true : false)">
                                <option [value]="i" *ngFor="let item of counter((item.quantity - item.splitedQuantity) + 1); index as i">{{i}}</option>
                              </select>
                              <span class="font-12 grey-color">
                                {{'checkout.of' | translate}} {{item.quantity - item.splitedQuantity}} {{'checkout.selected' | translate}}</span>
                            </div>
                          </ng-container>

                          <div class="ml-auto text-right">
                            <div class="grey-color fontLight font-14 d-ltr w-100" *ngIf="(item.quantity > 1) && !item.isWeight">
                              {{currency.currencyCode}} {{item.oneQtnPrice}}
                            </div>
                            <div class="fontLight d-ltr">
                              {{currency.currencyCode}}
                              <span class="fontMedium">{{item.totalItemprice}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </ng-container>
            <!-- End Item Split -->
          </ng-container>
          <!-- END Split -->

          <!-- Paid -->
          <app-paid-list [orderDetails]="details"></app-paid-list>
          <!-- END Paid -->

        </div>

        <div class="sheet-actions" *ngIf="!isSplit && CheckOutModel.checkOutType != 'Total'">
          <div>
            <button mat-button class="w-100 btn-grey-E text-uppercase fontSemiBold"
              (click)="backToSplitView()">{{'forms.Back' | translate}}</button>
          </div>
        </div>

        <div class="sheet-actions" *ngIf="isSplit">
          <div class="d-flex align-items-center">
            <button mat-button class="w-100 btn-grey-E text-uppercase fontSemiBold"
              (click)="closeSplit()">{{'forms.Back' | translate}}</button>

            <button mat-button color="primary" class="w-100 ml-2 text-uppercase fontSemiBold"
              (click)="getSplitedItemsDetails()"
              *ngIf="getSelectedItems().length && (splitType == 'item')">
              {{'checkout.Pay Selected' | translate}}</button>
          </div>
        </div>
      </ng-container>

    </div>

  </div>
</div>


<app-num-keypad
  *ngIf="manualCash"
  [title]="'checkout.Enter Paid Amount' | translate"
  [currency]="currency"
  [value]="manualCachToPay"
  (close)="payCashManual($event)"
></app-num-keypad>
